import Swiper from 'swiper/bundle';

let heroOptions = {
    loop: true,
    direction: "vertical",
    spaceBetween: 16,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false
    },
};

(function ($) {
    let swiper;

    function initSwiper() {
        swiper = new Swiper(".hero-type-4__inner", heroOptions);
    }

    function destroySwiper() {
        if (swiper) swiper.destroy();
        swiper = null;
    }
    // if there is a button, the slider will not be initialized
    // the slider works on <=1024 extensions
    function manageSwiper() {
        const heroLinkExists = $(".hero-type-4 .hero-type-4__inner").length > 0;
        const isMobile = $(window).width() <= 1024;

        if (heroLinkExists) {
            if (isMobile && !swiper) {
                initSwiper();
            } else if (!isMobile && swiper) {
                destroySwiper();
            }
        } else {
            $(".hero-type-4__inner").addClass("no-link");
            if (swiper) destroySwiper();
        }
    }

    $(document).ready(manageSwiper);
    $(window).on("resize", manageSwiper);

    // video feature
    function formatTime(s) {
        if (isNaN(s) || s === Infinity) return '00:00';
        s = Math.max(0, Math.floor(s));
        const h = Math.floor(s / 3600);
        const m = Math.floor((s % 3600) / 60);
        const sec = s % 60;
        const mm = (h ? String(m).padStart(2, '0') : String(m));
        const hh = String(h);
        const ss = String(sec).padStart(2, '0');
        return h ? `${hh}:${mm}:${ss}` : `${mm}:${ss}`;
    }

    function setOnlyThisPlaying(currentVideo) {
        $('video.hero-type-4__video').not(currentVideo).each(function () { this.pause(); });
    }

    $('.hero-type-4__video-wrp').each(function () {
        const $wrap  = $(this);
        const video  = $wrap.find('video.hero-type-4__video').get(0);

        const $centerToggle = $wrap.find('[data-action="toggle"].-toggle');
        const $barToggle    = $wrap.find('.hero-type-4__video-bar [data-action="toggle"]');
        const $muteBtn      = $wrap.find('[data-action="mute"]');
        const $fsBtn        = $wrap.find('[data-action="fs"]');

        const $seekWrap     = $wrap.find('.seek');
        const $seekRange    = $wrap.find('.seek-range');
        const $seekBuffer   = $wrap.find('.seek-buffer');
        const $seekProgress = $wrap.find('.seek-progress');
        const $timeCur      = $wrap.find('.time .current');
        const $timeDur      = $wrap.find('.time .duration');

        $seekBuffer.css('width', '0%');
        $seekProgress.css('width', '0%');

        // --- PLAY/PAUSE ---
        function togglePlay() {
            if (!$wrap.hasClass('-started')) $wrap.addClass('-started');

            if (video.paused) {
                setOnlyThisPlaying(video);
                video.play();
            } else {
                video.pause();
            }
        }
        $wrap.on('click', '[data-action="toggle"]', function (e) {
            e.preventDefault();
            togglePlay();
        });
        $(video).on('click', function () { togglePlay(); });

        // --- MUTE ---
        $wrap.on('click', '[data-action="mute"]', function (e) {
            e.preventDefault();
            video.muted = !video.muted;
            $wrap.toggleClass('-muted', video.muted);
            $(this).attr('aria-label', video.muted ? 'Unmute' : 'Mute');
        });

        // --- FULLSCREEN ---
        function isFullscreen() {
            return document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
        }
        function enterFS(el) {
            if (el.requestFullscreen) return el.requestFullscreen();
            if (el.webkitRequestFullscreen) return el.webkitRequestFullscreen();
            if (el.msRequestFullscreen) return el.msRequestFullscreen();
            if (video.webkitEnterFullscreen) return video.webkitEnterFullscreen();
        }
        function exitFS() {
            if (document.exitFullscreen) return document.exitFullscreen();
            if (document.webkitExitFullscreen) return document.webkitExitFullscreen();
            if (document.msExitFullscreen) return document.msExitFullscreen();
        }
        $wrap.on('click', '[data-action="fs"]', function (e) {
            e.preventDefault();
            if (isFullscreen()) exitFS(); else enterFS($wrap.get(0));
        });
        $(document).on('fullscreenchange webkitfullscreenchange MSFullscreenChange', function () {
            $wrap.toggleClass('-fs', !!isFullscreen());
        });

        // --- META/DURATION ---
        function writeDuration() {
            if (Number.isFinite(video.duration) && video.duration > 0) {
                $timeDur.text(formatTime(video.duration));
                return true;
            }
            return false;
        }
        if (!writeDuration()) {
            const onMeta = () => { if (writeDuration()) cleanup(); };
            const cleanup = () => {
                video.removeEventListener('loadedmetadata', onMeta);
                video.removeEventListener('loadeddata', onMeta);
                video.removeEventListener('canplay', onMeta);
                video.removeEventListener('durationchange', onMeta);
            };

            video.addEventListener('loadedmetadata', onMeta);
            video.addEventListener('loadeddata', onMeta);
            video.addEventListener('canplay', onMeta);
            video.addEventListener('durationchange', onMeta);

            const metaPoll = setInterval(() => {
                if (writeDuration()) { clearInterval(metaPoll); cleanup(); }
            }, 250);

            video.addEventListener('play', () => { writeDuration(); clearInterval(metaPoll); cleanup(); }, { once: true });

            if (!video.getAttribute('preload')) video.setAttribute('preload', 'metadata');
            if (video.readyState === 0 && video.currentSrc) {
                try { video.load(); } catch (e) {}
            }
        }

        // --- TIMEUPDATE / RANGE ---
        function updateProgressUI() {
            if (!isFinite(video.duration) || video.duration <= 0) return;

            const pct = (video.currentTime / video.duration) * 100;
            $seekRange.val(pct);
            $seekProgress.css('width', pct + '%');
            $timeCur.text(formatTime(video.currentTime));

            try {
                if (video.buffered && video.buffered.length) {
                    const end = video.buffered.end(video.buffered.length - 1);
                    const bufPct = Math.min(100, (end / video.duration) * 100);
                    $seekBuffer.css('width', bufPct + '%'); // <— буфер теж шириною
                }
            } catch (e) {}
        }
        video.addEventListener('timeupdate', updateProgressUI);
        video.addEventListener('progress', updateProgressUI);
        video.addEventListener('loadedmetadata', updateProgressUI);

        // Drag seek
        let seeking = false;
        $seekRange.on('input mousedown touchstart', function () { seeking = true; });
        $seekRange.on('input', function () {
            if (!isFinite(video.duration)) return;
            const pct = parseFloat(this.value || '0');
            $seekProgress.css('width', pct + '%'); //
        });
        $seekRange.on('change mouseup touchend', function () {
            if (!isFinite(video.duration)) return;
            const pct = parseFloat(this.value || '0');
            const t = (pct / 100) * video.duration;
            video.currentTime = t;
            seeking = false;
        });

        // --- VISUAL STATES ---
        video.addEventListener('play',  () => {
            $wrap.addClass('-playing').attr('data-state','playing');
            $centerToggle.attr('aria-label','Pause');
            $barToggle.attr('aria-label','Pause');
        });
        video.addEventListener('pause', () => {
            $wrap.removeClass('-playing').attr('data-state','paused');
            $centerToggle.attr('aria-label','Play');
            $barToggle.attr('aria-label','Play');
        });
        video.addEventListener('ended', () => {
            $wrap.removeClass('-playing').attr('data-state','ended');
        });

        $wrap.toggleClass('-muted', !!video.muted);

        // Resize
        let rt;
        $(window).on('resize', function () {
            clearTimeout(rt);
            rt = setTimeout(updateProgressUI, 120);
        });
    });

})(jQuery);